import WebComponent from '../../src/webComponents/WebComponent';
import {nanoid} from 'nanoid';
import {dataLayerPush} from './utils/dataLayerPush';
import {EVENT_NAMES, FRAGMENTS, HELPED_FRAGMENTS} from './enums/enums';
import {getLocation} from './utils/getLocation';
import {getEventId} from './utils/getEventId';
import {getFormData} from './utils/getFormData';
import {getUserData} from './utils/getUserData';
import {getLanguage} from './utils/getLanguage';
import {getCookie, setCookie} from './utils/cookie';
import {setHiddenInputs} from './utils/setHiddenInputs';
import {replaceSquareBrackets} from './utils/replaceSquareBrackets';

const DEBUG = false;
export default class FacebookBusiness extends WebComponent {

  constructor(props) {
    super(props);

    this.objects = {};

    this.handleLoadData = this.handleLoadData.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handlePUComplete = this.handlePUComplete.bind(this);
  }

  didMount() {
    this.objects.isSubmitted = false;
    this.objects.formEventData = {};
    this.objects.anuid = null;

    this.on('click', FRAGMENTS.FORM_SUBMIT, this.handleFormSubmit);
    document.addEventListener('partialUpdateComplete', this.handlePUComplete);
    window.addEventListener('load', this.handleLoadData);
  }

  willUnMount() {
    this.objects = {};

    document.removeEventListener('partialUpdateComplete', this.handlePUComplete);
    window.removeEventListener('load', this.handleLoadData);
  }

  handlePUComplete({detail: {hasError}}) {
    this.objects.isFormValidated = !hasError;
    if (!hasError && this.objects.isSubmitted) {
      dataLayerPush(this.objects.formEventData);
    }

    this.objects.isSubmitted = false;
    this.objects.formEventData = {};
  }

  handleLoadData() {
    // Na pořadí záleží! Nejdříve se musí zjistit cookie
    this.checkCookie();
    this.sendPageView();
  }

  handleFormSubmit(e) {
    const buttonElement = e.target.closest('button');
    if (!buttonElement) {
      console.error('Button element not found');
      return;
    }

    const formElement = buttonElement.closest('form');
    if (!formElement) {
      console.error('Form element not found');
      return;
    }

    const eventId = getEventId(buttonElement, formElement);
    if (!eventId) {
      console.error('Event ID not found');
      return;
    }

    setHiddenInputs(formElement, this.objects);
    const formData = getFormData(buttonElement, formElement, this.objects);
    const isRedirectAfterSubmit = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_FORM_REDIRECT_AFTER_SUBMIT)) || false;

    this.objects.formEventData = {
      event_name: EVENT_NAMES.FORM,
      event_id: eventId,
      ...formData,
      _clear: true
    };

    if (isRedirectAfterSubmit) {
      dataLayerPush(this.objects.formEventData);
    } else {
      this.objects.isSubmitted = true;
    }
  }

  checkCookie() {
    const cookie = getCookie();

    if (cookie) {
      this.objects.anuid = cookie;
    } else {
      const anuid = nanoid();
      this.objects.anuid = anuid;
      setCookie(anuid);
    }
  }

  sendPageView() {
    const {
      origin
    } = getLocation();

    const userData = getUserData(this.objects);

    // Chybí: Currency (měna), type (prototype) oproti Juanovi

    dataLayerPush({
      event_name: EVENT_NAMES.FG_PAGE_VIEW,
      event_id: `viewPage_${nanoid()}`,
      site: origin,
      language: getLanguage(),
      title: document.title,
      ...userData
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/FacebookBusiness.js